<template>
  <div v-if="paymentInfo">
    <div class="payment-title">
      编号:
      <span>{{ paymentInfo.guid }}</span>
    </div>
    <div v-if="optStatusLabel">
      支付状态:
      <span :class="optStatusClassName">{{ optStatusLabel }}</span>
    </div>
    <div v-if="paymentInfo.createTime > 0">
      <span>
        创建时间:
        {{ new Date(paymentInfo.createTime).format("YYYY-MM-dd hh:mm:ss") }}
      </span>
    </div>
    <div v-if="paymentInfo.paymentTradeNo">
      支付单号:
      <span>{{ paymentInfo.paymentTradeNo }}</span>
    </div>
    <div v-if="paymentInfo.bizUniqueId">
      业务单号:
      <span>
        {{ paymentInfo.bizUniqueId }}
      </span>
    </div>
    <div v-if="bizTypeLabel">
      业务类型:
      <span>{{ bizTypeLabel }}</span>
    </div>
    <div>
      支付方式:
      <span>{{ paymentTypeLabel }}</span>
    </div>
    <div v-if="paymentInfo.handledBy">
      经手人员:
      <span>{{ paymentInfo.handledBy }}</span>
    </div>
    <div>
      收款金额:
      <span> {{ paymentInfo.paymentAmount || 0 }}元 </span>
    </div>
    <div v-if="paymentInfo.refundingAmount > 0">
      退款中金额:
      <span> {{ paymentInfo.refundingAmount || 0 }}元 </span>
    </div>
    <div v-if="paymentInfo.optRemark">
      <div class="wordwrap">
        备注信息:
        <span class="payment-remark">{{ paymentInfo.optRemark }}</span>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
.payment-title {
  font-size: 16px;
  font-weight: bolder;
  line-height: 35px;
}

.payment-remark {
  font-weight: bolder;
  line-height: 30px;
  color: #000000;
}

.payment-status {
  width: auto;
  padding: 2px 5px;
  background-color: #ffffff;
  font-weight: 400;
  margin-right: 5px;
  border-radius: 5px;
  font-size: 14px;
  border: 1px solid #5c5c5c;
  color: #5c5c5c;

  &.paying {
    background-color: #3399ff;
    border: 1px solid #3399ff;
    color: #ffffff;
  }

  &.pay_error {
    background-color: #333333;
    border: 1px solid #333333;
    color: #ffffff;
  }

  &.refund {
    background-color: #333333;
    border: 1px solid #333333;
    color: #ffffff;
  }

  &.paid {
    background-color: #67c23a;
    border: 1px solid #67c23a;
    color: #ffffff;
  }
}
</style>

<script>
export default {
  props: {
    paymentInfo: {
      type: Object
    }
  },
  computed: {
    bizTypeLabel() {
      if (!this.paymentInfo) {
        return '';
      }
      if (this.paymentInfo.bizType === 'warehouse_order') {
        return '销售订单';
      }
      return this.paymentInfo.bizType;
    },
    paymentTypeLabel() {
      if (!this.paymentInfo) {
        return '';
      }
      if (this.paymentInfo.paymentType === 'wepay') {
        return '微信';
      } else if (this.paymentInfo.paymentType === 'alipay') {
        return '支付宝';
      }
      return this.paymentInfo.paymentType;
    },
    optStatusClassName() {
      if (!this.paymentInfo) {
        return '';
      }
      if (this.paymentInfo.optStatus == 0) {
        return 'payment-status paying';
      } else if (this.paymentInfo.optStatus == 1) {
        return 'payment-status pay_error';
      } else if (this.paymentInfo.optStatus == 2) {
        if (this.paymentInfo.refundedAmount > 0) {
          return 'payment-status refund';
        }
        return 'payment-status paid';
      }
      return '';
    },
    optStatusLabel() {
      if (!this.paymentInfo) {
        return '';
      }
      if (this.paymentInfo.optStatus == 0) {
        return '支付中';
      } else if (this.paymentInfo.optStatus == 1) {
        return '支付失败';
      } else if (this.paymentInfo.optStatus == 2) {
        if (this.paymentInfo.refundedAmount > 0) {
          return `已退款${this.paymentInfo.refundedAmount}元`;
        }
        return '已支付';
      }
      return '';
    }
  },
}
</script>
